module.exports = __webpack_public_path__ + "img/dp-xx-zs.2d6c020c.png";